// export function getEnvironmentSuffixFromHostname(hostname: string): string {
//   if (hostname === "localhost" || hostname.match(/lvh.me/)) {
//     return "-staging";
//   }

//   const subdomain = hostname.split(".")[0];
//   const subdomainParts = subdomain.split("-");

//   // This would be the case in production, i.e. wise.semeia.io
//   if (subdomainParts.length == 1) {
//     return "";
//   }

//   const environment = subdomainParts.slice(-1)[0];

//   if (environment == "test") {
//     return "-staging";
//   }

//   return `-${environment}`;
// }

export function getEnvironmentNameFromHostname(hostname) {
  if (hostname === "localhost" || hostname.match(/lvh.me/)) {
    return "local";
  }

  const subdomain = hostname.split(".")[0];
  const subdomainParts = subdomain.split("-");

  // This would be the case in production, i.e. wise.semeia.io
  if (subdomainParts.length == 1) {
    return "production";
  }

  const environment = subdomainParts.slice(-1)[0];

  if (environment == "dev") {
    return "development";
  }

  return environment;
}

export function getEnvironmentName() {
  return getEnvironmentNameFromHostname(window.location.hostname);
}

export function getEnvironmentSuffixFromHostname(hostname) {
  const environmentName = getEnvironmentNameFromHostname(hostname);
  switch (environmentName) {
    case "local":
    case "test":
      return "-master";
    case "production":
      return "";
    default:
      return `-${environmentName}`;
  }
}

export function getServiceUrlFromHostname(service: string, hostname: string) {
  const [, ...domainLabels] = hostname.split(".");
  return `https://${service}${getEnvironmentSuffixFromHostname(hostname)}.${domainLabels.join(".")}`;
}

export function getServiceUrl(service: string) {
  return getServiceUrlFromHostname(service, window.location.hostname);
}

export function isDevelopmentOrLocal() {
  const environmentName = getEnvironmentNameFromHostname(
    window.location.hostname
  );
  return environmentName == "development" || environmentName == "local";
}

export function isProduction() {
  return (
    getEnvironmentNameFromHostname(window.location.hostname) == "production"
  );
}

export default function runtimeEnvironment() {
  return getEnvironmentName();
}
